import { App, Component, createApp, h, ref } from 'vue';
import ModalMenu from '@use/useModalMenu/modalMenu.vue';
import router from '@/routs/router';
import { storePinia } from '@/storePinia';

let app: App | null;

const { body } = document;

body.insertAdjacentHTML('beforeend', '<div class="modal-menu"></div>');

const isOpen = ref(true);
let callBack: (() => void) | undefined;

interface IOptions {
  width?: string;
  // backgroundClose?: boolean;
  afterLeave?: () => void;
  // afterRemove?: () => void;
  // empty?: boolean;
}

export default function useModalMenu() {
  const show = (AppComponent: Component, options?: IOptions) => {
    try {
      isOpen.value = true;

      app = createApp(<ModalMenu>{{ default: () => h(AppComponent, options) }}</ModalMenu>, {
        isOpen,
        afterLeave: () => {
          app?.unmount();

          app = null;
          if (typeof options?.afterLeave === 'function') {
            options.afterLeave();
          }
        },
      });

      app.use(storePinia);
      app.use(router);

      app.mount('.modal-menu');
    } catch (error) {
      console.log(error);
    }
  };
  const hide = (): Promise<void> => {
    if (!app) {
      return new Promise((resolve) => {
        resolve();
      });
    }

    isOpen.value = false;

    return new Promise((resolve) => {
      callBack = resolve;
    });
  };

  return {
    show,
    hide,
  };
}
